import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { LoadingContent } from '../loading-content';

const spinnerContainerStyles = xcss({
	display: 'flex',
	minWidth: '160px',
	padding: 'space.250',
	justifyContent: 'center',
});

export function Loading({ loadingText }: { loadingText?: ReactNode }): React.JSX.Element {
	return (
		<Box xcss={spinnerContainerStyles}>
			<LoadingContent loadingText={loadingText ?? 'Loading dropdown menu...'} size="small" />
		</Box>
	);
}
